var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-row',{attrs:{"span":"24"}},_vm._l((_vm.movies),function(movie,index){return ((_vm.isAcc && movie.name === _vm.keyword) || !_vm.isAcc)?_c('van-col',{key:movie.id + '_' + index,attrs:{"span":"8"},on:{"click":function($event){return _vm.showDetail(movie)}}},[_c('VodInfo',{attrs:{"info":movie,"is-proxy":true}})],1):_vm._e()}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1a3296","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inApp/Vod/Result.vue
// module id = null
// module chunks = 